import {MessagingAllowlistChannel} from '@dms/api/core';

export const CHANNELS: readonly MessagingAllowlistChannel[] = ['email', 'sms'] as const;
